<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span class="title">医生名称</span>
          <el-input v-model="doctorName"
                    class="input_width"
                    clearable
                    @change="search"></el-input>
        </div>
        <div class="item">
          <span class="title">手机号</span>
          <el-input v-model="doctorPhone"
                    class="input_width"
                    clearable
                    @change="search"></el-input>
        </div>
        <div class="item">
          <span class="title">所在省市</span>
          <el-select v-model="province_id"
                     placeholder="请选择"
                     @change="search"
                     class="input_width"
                     clearable>
            <el-option v-for="item in proList"
                       :key="item.province_id"
                       :label="item.name"
                       :value="item.province_id"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="title">来源</span>
          <el-select v-model="doc_from"
                     placeholder="请选择"
                     class="input_width"
                     @change="search">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="title">APP版本号</span>
          <el-input v-model="version"
                    class="input_width"
                    clearable
                    @change="search"></el-input>
        </div>
        <div class="item">
          <span class="title">版本</span>
          <el-select v-model="system_version_type"
                     placeholder="请选择"
                     @change="search"
                     class="input_width"
                     clearable>
            <el-option label="全部"
                       :value="0"></el-option>
            <el-option label="标准版"
                       :value="1"></el-option>
            <el-option label="大字版"
                       :value="2"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="title">实名认证</span>
          <el-radio-group v-model="real_name_auth"
                          @change="search">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
        <div class="item">
          <span class="title">是否测试</span>
          <el-radio-group v-model="is_test"
                          @change="search">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
          <el-button type="info"
                     style="
              background-color: #eceff2;
              color: #747981;
              margin: 0 10px 0 20px;
            "
                     @click="search">查询</el-button>
          <el-button type="primary"
                     icon="el-icon-plus"
                     @click="AddDoctor"
                     :disabled="
              module_id_array[0] ? !module_id_array.includes('22') : false
            ">添加医生</el-button>
        </div>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%; min-width: 1000px"
                  :header-cell-style="{ background: '#F5F5F5' }"
                  v-loading="loading"
                  element-loading-text="拼命加载中"
                  element-loading-background="rgba(0, 0, 0,0.1)">
          <el-table-column prop="user_name"
                           label="医生头像"
                           width="80">
            <template slot-scope="scope">
              <div style="border: solid 1px #d3d3d3; width: 42px; height: 42px">
                <img :src="scope.row.head_img"
                     alt
                     style="width: 40px; height: 40px" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="update_time"
                           label="认证时间"></el-table-column>
          <el-table-column prop="doctor_name"
                           label="医生信息">
            <template slot-scope="scope">
              <div>
                <span @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor: pointer">{{ scope.row.doctor_name }}</span>
                <span v-if="scope.row.sex == 1"
                      style="margin-left: 16px">男</span>
                <span v-if="scope.row.sex == 2"
                      style="margin-left: 16px">女</span>
              </div>
              <div>
                <span>{{ scope.row.phone }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="province_name"
                           label="所在省市"></el-table-column>

          <el-table-column label="认证申请单"
                           width="100">
            <template slot-scope="scope">
              <div style="color: #669961; cursor: pointer"
                   @click="toshenhelist(scope.row)">
                {{ scope.row.auth_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最新审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.verify_status == 1">草稿中</span>
              <span v-if="scope.row.verify_status == 2"
                    style="color: #669961">审核中</span>
              <span v-if="scope.row.verify_status == 3">审核通过</span>
              <span v-if="scope.row.verify_status == 4"
                    style="color: #d0523c">审核不通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="hospital"
                           label="医院名称"></el-table-column>
          <el-table-column prop="department_name"
                           label="科室"></el-table-column>
          <el-table-column label="状态"
                           width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status">正常</span>
              <span v-else
                    style="color: #d0523c">锁定</span>
            </template>
          </el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span v-if="scope.row.doc_from == 1">APP注册</span>
              <span v-if="scope.row.doc_from == 2">平台添加</span>
              <span v-if="scope.row.doc_from == 3">邀请注册</span>
              <span v-if="scope.row.doc_from == 4">接口同步</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="320">
            <template slot-scope="scope">
              <el-button @click="toDetail(scope.row.doctor_id)"
                         type="text">查看详情</el-button>
              <el-button @click="shenQing(scope.row)"
                         type="text"
                         v-if="scope.row.verify_status == 3 || scope.row.verify_status == 4"
                         :disabled="module_id_array[0] ? !module_id_array.includes('25') : false">修改认证</el-button>
              <el-button @click="upstatus(scope.row.doctor_id, 0)"
                         type="text"
                         v-if="scope.row.status == 1"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('24') : false
                ">锁定</el-button>
              <el-button @click="upstatus(scope.row.doctor_id, 1)"
                         type="text"
                         v-if="scope.row.status == 0"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('24') : false
                ">解锁</el-button>
              <el-button @click="showCancelDia(scope.row.doctor_id)"
                         type="text"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('924') : false
                ">注销</el-button>
              <span style="margin-left: 10px; color: #669961"
                    v-if="
                  module_id_array[0] ? module_id_array.includes('186') : true
                ">
                测试
                <el-switch v-model="scope.row.is_test"
                           active-color="#669961"
                           @change="
                    (value) => {
                      return setTest(value, scope.row.doctor_id);
                    }
                  "></el-switch>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pagesize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalNum"
                       style="margin: 20px 0"></el-pagination>
      </div>
    </div>
    <!-- 添加医生弹窗 -->
    <el-dialog title="添加医生"
               :visible.sync="add_doctor"
               width="600px"
               :close-on-click-modal="false">
      <div class="myform">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="120px"
                 class="demo-ruleForm">
          <el-form-item label="医生姓名"
                        prop="doctor_name">
            <el-input v-model="ruleForm.doctor_name"
                      maxlength="20"
                      style="width: 420px"></el-input>
          </el-form-item>
          <el-form-item label="性别"
                        prop="doctor_sex">
            <div style="text-align: left">
              <el-radio v-model="ruleForm.doctor_sex"
                        :label="1">男</el-radio>
              <el-radio v-model="ruleForm.doctor_sex"
                        :label="2">女</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="doctor_phone">
            <el-input v-model="ruleForm.doctor_phone"
                      style="width: 220px"></el-input>
          </el-form-item>
          <el-form-item label="邀请码">
            <el-input v-model="ruleForm.recommender_code"
                      style="width: 220px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 1px; background-color: #d9dadd; margin-bottom: 14px"></div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer"
              class="dialog-footer">
          <el-button plain
                     @click="add_doctor = false"
                     style="width: 92px"
                     size="medium">关闭</el-button>
          <el-button type="primary"
                     @click="submit('ruleForm')"
                     style="width: 92px"
                     size="medium">保存</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 注销弹窗 -->
    <el-dialog title="提 示"
               :visible.sync="cancelDia"
               width="700px"
               :close-on-click-modal="false">
      <div class="content">
        <div style="color: #ff7200">
          注意：注销账户前，需核实医生问诊、处方、账户等情况。
        </div>
        <div>
          <div class="green">必须处理（以下数据须全部清零后，才可以注销）</div>
          <div class="box">
            <div class="item">
              <div class="title">● 问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin: 0 30px 0 10px">{{ statistics_info.to_be_confirmed_consult_count }}条</span>
                <span>咨询中</span>
                <span style="margin-left: 10px">{{ statistics_info.consulting_consult_count }}条</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 预约问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin-left: 10px">{{ statistics_info.to_be_confirmed_register_count }}条</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 分享开方处方</div>
              <div style="padding-left: 12px">
                <span>允许购买</span>
                <span style="margin-left: 10px">{{
                    statistics_info.allow_purchase_agreement_prescription_count
                  }}个</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 处方记录</div>
              <div style="padding-left: 12px">
                <span>待取药</span>
                <span style="margin: 0 30px 0 10px">{{
                    statistics_info.medicine_to_be_taken_prescription_count
                  }}条</span>
                <span>待审方</span>
                <span style="margin: 0 30px 0 10px">{{
                    statistics_info.pending_party_prescription_count
                  }}条</span>
                <span>已通过</span>
                <span style="margin-left: 10px">{{ statistics_info.passed_prescription_count }}条</span>
              </div>
            </div>
          </div>
          <div class="green">非必须处理（参考）</div>
          <div class="box">
            <div class="item">
              <div class="title">● 诊后服务</div>
              <div style="padding-left: 12px">
                <span>待诊后服务(处方)</span>
                <span style="margin-left: 10px">{{ statistics_info.after_treatment_service_count }}条</span>
              </div>
            </div>
          </div>
          <div class="green">资金账户</div>
          <div class="box">
            <div class="pricebox">
              <div class="priceitem">
                <div class="num">{{ account_info.sa_money }}</div>
                <div class="gray">税前总收入</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.taxation_money }}</div>
                <div class="gray">扣缴税额</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.pay_money }}</div>
                <div class="gray">税后总收入</div>
              </div>
            </div>
            <div class="pricebox">
              <div class="priceitem">
                <div class="num red">{{ account_info.wait_money }}</div>
                <div class="gray">待结算金额（未入账）</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.bk_price }}</div>
                <div class="gray">平台补扣/补贴</div>
              </div>
              <div class="priceitem">
                <div class="num red">{{ account_info.t_price }}</div>
                <div class="gray">账户余额</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.settle_money }}</div>
                <div class="gray">可提现余额</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.no_settle_money }}</div>
                <div class="gray"
                     style="width: 72px">不可提现余额</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ account_info.y_pay_money }}</div>
                <div class="gray">总提现</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer"
              class="dialog-footer">
          <el-button plain
                     @click="cancelDia = false"
                     style="width: 92px"
                     size="medium">取消操作
          </el-button>
          <el-button type="primary"
                     @click="cancelDoctor"
                     style="width: 92px"
                     size="medium">确认注销</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import doctor from '../../../api/doctor';
import _ from 'lodash';
import platform from '../../../api/platform';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      loading: true,
      doctorName: '',
      doctorPhone: '',
      is_test: 2,
      real_name_auth: '',
      cancelDia: false,
      account_info: {},
      statistics_info: {},
      doctor_id: '',
      add_doctor: false,
      doc_from: '',
      province_id: '',
      version: '',
      system_version_type: 0,
      proList: [],
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: 'APP注册'
        },
        {
          value: 2,
          label: '平台添加'
        },
        {
          value: 3,
          label: '邀请注册'
        },
        {
          value: 4,
          label: '接口同步'
        }
      ],
      ruleForm: {
        doctor_name: '',
        doctor_sex: '',
        doctor_phone: '',
        recommender_code: ''
      },
      rules: {
        doctor_name: [
          {
            required: true,
            message: '请输入医生姓名',
            trigger: 'blur'
          },
          { max: 20, message: '请输入20位以内的字符', trigger: 'blur' },
          // {
          //   pattern: /^[\u4e00-\u9fa5]{0,}$/,
          //   message: '请输入6位以内汉字',
          //   trigger: ['blur', 'change']
          // }
        ],
        doctor_sex: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ],
        doctor_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^(1[3456789])\d{9}$/,
            message: '请输入正确手机号',
            trigger: 'blur'
          }
        ]
      },
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //设置测试账号
    setTest(value, doctor_id) {
      let text = '';
      let status = '';
      if (value) {
        text = '确定将该账号设置为测试账号？';
        status = 1;
      } else {
        text = '确定取消测试账号？';
        status = 2;
      }
      this.$confirm(text, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          doctor.setTestDoctor({ doctor_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('设置成功');
              this.getList();
            } else {
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //获取医生列表
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        auth_status: 2,
        doctor_name: this.doctorName,
        doctor_phone: this.doctorPhone,
        doc_from: this.doc_from,
        province_id: this.province_id,
        is_test: this.is_test,
        real_name_auth: this.real_name_auth,
        version: this.version,
        system_version_type: this.system_version_type
      };
      doctor
        .doctorList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToTime(item.update_time);
              item.is_test = item.is_test == 1 ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //添加医生按钮
    AddDoctor() {
      this.ruleForm = {
        doctor_name: '',
        doctor_sex: '',
        doctor_phone: ''
      };
      this.add_doctor = true;
    },
    //添加医生
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let addData = this.ruleForm;
          doctor
            .addDoctor(addData)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(
                  '保存成功！登录密码已发送短信到手机。手机密码随机生成，由8位字母和数字组合。'
                );
                this.add_doctor = false;
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //注销医生弹窗
    showCancelDia(doctor_id) {
      this.doctor_id = doctor_id;
      this.axios
        .post('platform/doctor/getDoctorCurrentAccountNumber', { doctor_id })
        .then((res) => {
          this.account_info = res.data.account_info;
          this.statistics_info = res.data.statistics_info;
          this.cancelDia = true;
        });
    },
    //注销医生
    cancelDoctor() {
      if (
        this.statistics_info.to_be_confirmed_consult_count ||
        this.statistics_info.consulting_consult_count ||
        this.statistics_info.to_be_confirmed_register_count ||
        this.statistics_info.allow_purchase_agreement_prescription_count ||
        this.statistics_info.medicine_to_be_taken_prescription_count ||
        this.statistics_info.pending_party_prescription_count ||
        this.statistics_info.passed_prescription_count
      ) {
        this.$message.error('必须处理内容不为0，不可以注销。');
        return false;
      }
      let doctor_id = this.doctor_id;
      this.axios
        .post('platform/doctor/cancelDoctorAccount', { doctor_id })
        .then((res) => {
          this.$message.success('该医生账号已注销');
          this.getList();
          this.cancelDia = false;
        });
    },
    //详情
    toDetail(doctor_id) {
      this.$router.push({
        path: 'doctordetail',
        query: { doctor_id }
      });
    },
    //修改认证
    shenQing(row) {
      this.$router.push({
        path: 'shenqing',
        query: {
          doctor_id: row.doctor_id,
          doctor_name: row.doctor_name_str,
          sex: row.sex == 1 ? '男' : '女',
          phone: row.phone,
          reviewed_id: row.reviewed_id,
          is_save: 1
        }
      });
    },
    //锁定解锁
    upstatus(doctor_id, status) {
      if (!status) {
        this.$confirm('锁定后医生账号不可登录，确定操作？', '提示消息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            doctor.updateDoctorStatus({ doctor_id, status }).then((res) => {
              if (res.code == 0) {
                this.$message.success('医生状态已更改');
                this.getList();
              }
            });
          })
          .catch(() => {});
      } else {
        doctor
          .updateDoctorStatus({ doctor_id, status })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('医生状态已更改');
              this.getList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //点击申请单去审核列表
    toshenhelist(row) {
      this.$router.push({
        name: 'shenhelist',
        params: {
          doctor_name: row.doctor_name,
          phone: row.phone
        }
      });
    }
  },
  created() {
    this.getProvince();
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 210px);
}
.searchbox {
  display: flex;
  margin-bottom: 0px;
  align-items: center;
  flex-wrap: wrap;
  .item {
    margin-bottom: 16px;
  }
  .title {
    text-align: right;
    margin-right: 6px;
    display: inline-block;
    width: 80px;
  }
  .input_width {
    width: 160px;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 20px;
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
  }
  .pricebox {
    display: flex;
    align-items: center;
    padding: 15px 0;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 20px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: '';
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      width: 60px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
</style>
